module.exports = __webpack_public_path__ + "static/media/71.96f197fa.wav";